import { __decorate } from "tslib";
// @ts-nocheck
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { AbstractDialogInputService } from '@patsnap/tahiti-core';
let TransferSpaceOptionServiceImp = class TransferSpaceOptionServiceImp extends AbstractDialogInputService {
    constructor() {
        super(...arguments);
        this.component = () => import('@/presentation/components/workspaces/TransferWorkspaceDialogNew.vue');
    }
};
TransferSpaceOptionServiceImp = __decorate([
    injectable()
], TransferSpaceOptionServiceImp);
export { TransferSpaceOptionServiceImp };
